"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Icon = _interopRequireDefault(require("../../components/Icon/Icon"));
var _LunaLink = _interopRequireDefault(require("../LunaLink/LunaLink"));
var _CTASectionMethods = require("../CTASection/CTASectionMethods");
var _BoundedCardLinkIcon = require("../BoundedCard/BoundedCardLinkIcon");
require("./SearchPromoCard.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const SearchPromoCard = _ref => {
  let {
    header,
    eyebrow,
    label,
    text,
    linkLabel,
    cta,
    icons,
    destination,
    redisplayDays,
    id,
    inDateRange,
    displayPromoCard,
    setStoredPromoCard,
    setDisplayPromoCard,
    checkDisplayPromoCard
  } = _ref;
  const currentDate = new Date().getTime();
  (0, _react.useEffect)(() => {
    if (typeof window !== "undefined") {
      setStoredPromoCard(id, {
        date: currentDate,
        redisplay: redisplayDays
      });
      setDisplayPromoCard(checkDisplayPromoCard(currentDate, id, redisplayDays));
    }
  }, [currentDate]);
  const renderIcons = () => {
    if (!icons?.length) return null;
    const displayedIcons = icons.length > 2 ? icons.slice(0, 2) : icons;
    return displayedIcons.map((icon, i) => /*#__PURE__*/_react.default.createElement(_Icon.default, {
      key: i,
      className: "ter-search-promo-card__top--right--icon",
      type: icon.type,
      size: "42px",
      color: "#242D2F"
    }));
  };
  if (!displayPromoCard || !inDateRange) return null;
  return /*#__PURE__*/_react.default.createElement("section", {
    className: "ter-search-promo-card"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-search-promo-card__top"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-search-promo-card__top--left"
  }, eyebrow && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-search-promo-card__top--left--eyebrow-section"
  }, label && /*#__PURE__*/_react.default.createElement("p", {
    className: "ter-search-promo-card__top--left--eyebrow-section--label"
  }, label), /*#__PURE__*/_react.default.createElement("h1", {
    className: "ter-search-promo-card__top--left--eyebrow-section--eyebrow"
  }, eyebrow)), header && /*#__PURE__*/_react.default.createElement("h2", {
    className: "ter-search-promo-card__top--left--header",
    style: !eyebrow ? {
      marginTop: "24px"
    } : {}
  }, header)), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-search-promo-card__top--right"
  }, icons?.length && /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-search-promo-card__top--right--icon-container"
  }, renderIcons()), text && /*#__PURE__*/_react.default.createElement("p", {
    className: "ter-search-promo-card__top--right--text"
  }, text))), /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-search-promo-card__bottom"
  }, linkLabel && /*#__PURE__*/_react.default.createElement("p", {
    className: "ter-search-promo-card__bottom--linkLabel"
  }, linkLabel), cta?.url && /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
    className: "ter-search-promo-card__bottom--link",
    to: cta.url,
    onClick: cta.onClick
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "ter-search-promo-card__bottom--link-text"
  }, cta.text), /*#__PURE__*/_react.default.createElement(_BoundedCardLinkIcon.CardLinkIcon, {
    iconClass: "ter-search-promo-card__bottom--link-icon",
    external: (0, _CTASectionMethods.checkForExternalLink)(cta.url)
  }))));
};
var _default = SearchPromoCard;
exports.default = _default;